import React, { useContext, useEffect } from "react";

import Step1 from "@pages/NewPQRS/Step1";
import Step2 from "@pages/NewPQRS/Step2";
import Step3 from "@pages/NewPQRS/Step3";

import { AppContext } from "@context/index";
import { useLocation } from "react-router-dom";
import SearchCase from "@components/SearchCase";
import { ContainerSearch } from "./style";
import NotFound from "@pages/NotFound";
import Layout from "@components/Layout";
import { TypesPersonality } from "@context/types/legalpersonality";
import { TypesPage } from "@context/types/page";
import { TypesAnonymous } from "@context/types/anonymous";
import { TypesData } from "@context/types/data";
import { TypesPatient } from "@context/types/patient";

const NewPQRS = () => {
  const { state, dispatch } = useContext(AppContext);
  const location = useLocation();
  useEffect(() => {
    return () => {
      dispatch({ type: TypesPersonality.Natural });
      dispatch({ type: TypesPage.Reset });
      dispatch({ type: TypesAnonymous.NotAnonymous });
      dispatch({ type: TypesData.ResetData });
      dispatch({ type: TypesPatient.Reset });
    };
  }, []);
  if (!location.state) {
    return <NotFound />;
  }
  const { page } = state;
  const steps = [<Step1 />, <Step2 />, <Step3 />];
  return (
    <Layout>
      <ContainerSearch>
        <SearchCase />
      </ContainerSearch>
      {steps[page]}
    </Layout>
  );
};

export default NewPQRS;
